import MapRoute from "../../../../../common/components/map/types/map-route";
import { GpsPlanEntryRecordsItem } from "../../../../../common/services/gps/plan-entry-records/gps-plan-entry-records";
import {
  SearchRoadRoutingResponseRouteGeometryCoordinate,
  SearchRoadRoutingResponseRoute,
} from "../../../../../common/utils/search-road-route/search-road-routing.response";

const createCompletedMapRouteWaypoints = (
  responseItems: GpsPlanEntryRecordsItem[],
): MapRoute["waypoints"] => {
  const sortedResponseItems = responseItems.sort(
    (itemA, itemB) =>
      new Date(itemA.recordTime).getTime() -
      new Date(itemB.recordTime).getTime(),
  );

  const waypoints: MapRoute["waypoints"] = sortedResponseItems.map((item) => ({
    latitude: item.latitude,
    longitude: item.longitude,
  }));

  return waypoints;
};

const createCompletedMapRoute = (
  responseItems: GpsPlanEntryRecordsItem[],
): MapRoute => {
  const waypoints = createCompletedMapRouteWaypoints(responseItems);

  const mapRoute: MapRoute = {
    waypoints,
    options: {
      color: "#3699ff",
    },
  };

  return mapRoute;
};

const createPlannedMapRouteWaypoints = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
): MapRoute["waypoints"] => {
  return routesResponseGeometryCoordinates.map((coordinate) => {
    return {
      latitude: coordinate[1],
      longitude: coordinate[0],
    };
  });
};

const createPlannedMapRoute = (
  routesResponseGeometryCoordinates: SearchRoadRoutingResponseRouteGeometryCoordinate[],
): MapRoute => {
  const waypoints = createPlannedMapRouteWaypoints(
    routesResponseGeometryCoordinates,
  );

  return {
    waypoints,
  };
};

const createPlannedMapRoutes = (
  responseRoutes: SearchRoadRoutingResponseRoute[],
): MapRoute[] => {
  return responseRoutes.map((responseRoute) =>
    createPlannedMapRoute(responseRoute.geometry.coordinates),
  );
};

const billingsMapRouteFactory = {
  createCompletedMapRoute,
  createPlannedMapRoutes,
  createPlannedMapRoute,
};

export default billingsMapRouteFactory;
